module.exports = __webpack_public_path__ + "files/1af0df96de71843e298802c8b4b02f58.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-italic-webfont.woff2
// module id = 689
// module chunks = 60